import { render } from "./ProductPlattformManager.vue?vue&type=template&id=5f6cf644&scoped=true"
import script from "./ProductPlattformManager.vue?vue&type=script&lang=js"
export * from "./ProductPlattformManager.vue?vue&type=script&lang=js"

import "./ProductPlattformManager.vue?vue&type=style&index=0&id=5f6cf644&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6cf644"]])

export default __exports__